import { Alert, Button, Center, Loader, Stack, Title, Text, Code } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useEffect, type ReactNode } from "react";
import { useUser } from "./useUser.js";

const ADMIN_ROLE = "admin";
const LOGIN_PROVIDER = "aad";

export function AuthGate({ children }: { children: ReactNode }) {
  const user = useUser();

  // Resolved to anonymous → redirect to SWA's Entra login.
  useEffect(() => {
    if (user === null) {
      const here = window.location.pathname + window.location.search;
      window.location.replace(
        `/.auth/login/${LOGIN_PROVIDER}?post_login_redirect_uri=${encodeURIComponent(here)}`
      );
    }
  }, [user]);

  if (user === undefined || user === null) {
    return <Center h="100vh"><Loader /></Center>;
  }

  if (!user.userRoles.includes(ADMIN_ROLE)) {
    return (
      <Center h="100vh">
        <Stack maw={520} p="md" gap="md">
          <Title order={2}>Admin role required</Title>
          <Alert color="yellow" icon={<IconLock size={16} />} title={`Signed in as ${user.userDetails}`}>
            <Text size="sm">
              Your Entra account doesn't have the <Code>admin</Code> role on this Static Web App.
              Ask your administrator to invite you: Azure portal → <Code>stapp-alert-sorting</Code>
              → Role management → Invite.
            </Text>
          </Alert>
          <Button variant="default" onClick={() => { window.location.href = "/.auth/logout"; }}>
            Sign out
          </Button>
        </Stack>
      </Center>
    );
  }

  return <>{children}</>;
}
